import {useState, useEffect, useContext, useCallback} from 'react';
import {Link, Navigate, useNavigate} from 'react-router-dom';
import style from './CategoryTages.module.css';//import Pagination from '../../UI/Pagination/Pagination';
import { appUsers,fetchAppUsers,disableParentCode,enableParentCode,fetchAppUsersByCode,fetchAppUsersByCatID,fetchParents } from '../../services/notification.services';
import AuthContext from "../../store/auth-context";
import '../Style/Table-style.css';
import fontSize from '../Style/FontSize.module.css';
import Pagination from '../UI/Pagination/Pagination';
import button from '../Style/ButtonStyle.module.css';
import font from '../Style/FontFamily.module.css';
import common from '../Style/common.module.css';
import tableStyle from '../Style/TableModel.module.css';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
let pageSize = 10;
const ParentsDetails = (props) => {
    console.log('===p===',props);
    
    // All hooks must be declared first, unconditionally
    const [modalIsOpen, setIsOpen] = useState(false);
    const [status, setStatus] = useState<any>(null)
    const authCtx = useContext(AuthContext);
    const navigate = useNavigate();
    
    const [organisationCodes, setOrganisationCodes] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [sortColumn, setSortColumn] = useState('createDate');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');

    const [currentPage, setCurrentPage] = useState(1);
    const [PageSize, setPageSize] = useState(pageSize);

    const orgUuid = authCtx?.userData?.orgId;
    
    // Handler functions
    const modalClose = useCallback(() => {
        setIsOpen(false)
    }, []);
    
    const deactiveNotificationHandler = (uid) => {
        setIsOpen(true);
        setStatus(uid)
        console.log(uid)
    }
    
    const KEY_NAME_ESC = 'Escape';
    const KEY_EVENT_TYPE = 'keyup';
    const handleEscKey = useCallback((event) => {
        if (event.key === KEY_NAME_ESC) {
            modalClose();
        }
    }, [modalClose]);
    
    // Get codeVal early for use in effects
    let codeVal = props.sCode;
    let groupID = 0;
    //console.log('======',codeVal.indexOf("&&"))
    if(codeVal !== '' && isNaN(codeVal) === true){
       let codeArr = codeVal.split("&&");
       console.log("codeAr",codeArr)
       const groupName = codeArr[0];
       groupID = codeArr[1];
       codeVal = groupName;
       console.log("groupIDName",groupID,groupName)
    }
    
    // Effects
    useEffect(() => {
        document.addEventListener(KEY_EVENT_TYPE, handleEscKey, false);
        return () => {
            document.removeEventListener(KEY_EVENT_TYPE, handleEscKey, false);
        };
    }, [handleEscKey]);
    
    useEffect(() => {
        setIsLoading(true);
        
        if(codeVal === ''){
            fetchParents(orgUuid,authCtx.token)
            .then((response) => {
                console.log('Fetch Parents Response:', response);
                const userList = response?.userList || response?.data?.userList || [];
                console.log('Extracted userList:', userList);
                setOrganisationCodes(Array.isArray(userList) ? userList : []);
                setIsLoading(false);
            }).catch((err) => {
                console.error('Error fetching parents:', err);
                setOrganisationCodes([]);
                setIsLoading(false);
            });
        }else if(isNaN(codeVal) === true){
            fetchAppUsersByCatID(orgUuid,groupID,authCtx.token)
            .then((response) => {
                console.log('Fetch App Users By Category Response:', response);
                const userList = response?.userList || response?.data?.userList || [];
                console.log('Extracted userList:', userList);
                setOrganisationCodes(Array.isArray(userList) ? userList : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching app users by category:', err);
                setOrganisationCodes([]);
                setIsLoading(false);
            });
        }else{
            fetchAppUsersByCode(orgUuid,codeVal,authCtx.token)
            .then((response) => {
                console.log('Fetch App Users By Code Response:', response);
                const userList = response?.userList || response?.data?.userList || [];
                console.log('Extracted userList:', userList);
                setOrganisationCodes(Array.isArray(userList) ? userList : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching app users by code:', err);
                setOrganisationCodes([]);
                setIsLoading(false);
            });
        }

    }, [codeVal,orgUuid,authCtx.token,authCtx.userData.usertype,groupID]);

    // Guard: if no auth data, show loading state
    if (!authCtx?.userData || !orgUuid) {
        return <div>Loading authentication...</div>;
    }

    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    //console.log('first',codeVal)
    const showHandler = (e) => {
        setPageSize(+e.target.value);
        setCurrentPage(1);
    }
    //console.log('filtercode',codeVal);

    const disableParent = (uid,ucode, codeUserStatus) => {
            if(uid){
            const userPostData = {
                        uid: uid,
                        ucode: ucode,
                        orgUuid: orgUuid,
             }
            disableParentCode(userPostData,authCtx.token)
            .then((response) => {
                console.log('Disable parent response:', response);
                fetchParents(orgUuid,authCtx.token).then((refreshResponse) => {
                    const userList = refreshResponse?.userList || refreshResponse?.data?.userList || [];
                    console.log('Refreshed userList after disable:', userList);
                    setOrganisationCodes(Array.isArray(userList) ? userList : []);
                    toast.success("User Deactivated successfully!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        type: 'success'
                    });
                    setIsOpen(false);
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.error('Error refreshing parents after disable:', err);
                    setIsLoading(false);
                });
            })
            .catch((err) => {
                console.error('Error disabling parent code:', err);
                setIsLoading(false);
            });
            }
    }

    const enableParent = (uid,ucode) => {
            if(uid){
            const userPostData = {
                        uid: uid,
                        ucode: ucode,
                        orgUuid: orgUuid,
             }
            enableParentCode(userPostData,authCtx.token)
            .then((response) => {
                console.log('Enable parent response:', response);
                fetchParents(orgUuid,authCtx.token).then((refreshResponse) => {
                    const userList = refreshResponse?.userList || refreshResponse?.data?.userList || [];
                    console.log('Refreshed userList after enable:', userList);
                    setOrganisationCodes(Array.isArray(userList) ? userList : []);
                    toast.success("User Activated successfully!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        type: 'success'
                    });
                    setIsOpen(false);
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.error('Error refreshing parents after enable:', err);
                    setIsLoading(false);
                });
            })
            .catch((err) => {
                console.error('Error enabling parent code:', err);
                setIsLoading(false);
            });
            }
    }

    const goBackParent = (codeVal) => {
        if(isNaN(codeVal)==true){
            navigate("/Organisation/#category");
            props.setSelectedCode('');
            props.setKey('first');
        }else{
           navigate("/Organisation/#parents");
            props.setSelectedCode('');
            props.setKey('Fourth');
        }

    }
    const searchHandler = (e) => {
        setSearchText(e.target.value);
        setCurrentPage(1);
    }
    
    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
        setCurrentPage(1);
    };
    
    const getSortIcon = (column: string) => {
        if (sortColumn !== column) {
            return <span style={{ opacity: 0.3 }}>⇅</span>;
        }
        return sortDirection === 'asc' ? '↑' : '↓';
    };
    
    const safeOrganisationCodes = Array.isArray(organisationCodes) ? organisationCodes : [];
    const totalCount = safeOrganisationCodes.length;
    const searchTextArray = searchText.toLowerCase().trim().split(' ');
    const searchParentData = safeOrganisationCodes.filter(parentdata => {
        if (!parentdata || !parentdata.email) return false;
        return searchTextArray.every(i => parentdata.email.toLowerCase().indexOf(i) > -1)
        }
    ).sort((a, b) => {
        let compareA, compareB;
        
        switch (sortColumn) {
            case 'firstName':
                compareA = a.firstName?.toLowerCase() || '';
                compareB = b.firstName?.toLowerCase() || '';
                break;
            case 'lastName':
                compareA = a.lastName?.toLowerCase() || '';
                compareB = b.lastName?.toLowerCase() || '';
                break;
            case 'email':
                compareA = a.email?.toLowerCase() || '';
                compareB = b.email?.toLowerCase() || '';
                break;
            case 'code':
                compareA = a.code || '';
                compareB = b.code || '';
                break;
            case 'createDate':
                compareA = new Date(a.createDate).getTime();
                compareB = new Date(b.createDate).getTime();
                break;
            case 'codeUserStatus':
                compareA = a.codeUserStatus || '';
                compareB = b.codeUserStatus || '';
                break;
            default:
                compareA = new Date(a.createDate).getTime();
                compareB = new Date(b.createDate).getTime();
        }
        
        if (sortDirection === 'asc') {
            return compareA > compareB ? 1 : compareA < compareB ? -1 : 0;
        } else {
            return compareA < compareB ? 1 : compareA > compareB ? -1 : 0;
        }
    });
    const parentData = searchParentData.slice(firstPageIndex, lastPageIndex);
    
    //const parentData = organisationCodes.slice(firstPageIndex, lastPageIndex);
    return (
        <>
            <div className={style.creatUserArea}>
                    {/* <h4 className={[fontSize.lgSize + ' ' + common.pageTitle + ' ' + font.fontMedium]} >Settings</h4> */}
                    {/* <div className={style.settingbutton}>

                        {authCtx.userData.user_id!="39" && <button onClick={recipientModalHendler} className={button.iconBtn + ' ' + button.modalBtn + ' ' + button.redButton}>
                            <i className="icon icon-plus-circle"></i> Create New User</button>}
                    </div> */}
                    <div style={{marginTop:'20px',marginBottom:'5px',display:'flex',justifyContent:'flex-end'}}>
                        <div className={'form-group ' + tableStyle.hassearch}>
                        <label htmlFor="SearchInput" className='hidenText'>Search</label>
                        <input value={searchText} onChange={searchHandler} className={tableStyle.searchInput} type="search" placeholder="Search..." />
                        <i className={"icon icon-search2 " + tableStyle.searchIcon}></i>
                        </div>
                    </div>
            </div>
            {isLoading && <div className={style.creatUserArea} style={{textAlign: 'center', padding: '20px'}}>
                <p>Loading parent data...</p>
            </div>}
            {!isLoading && safeOrganisationCodes.length === 0 && <div className={style.creatUserArea} style={{textAlign: 'center', padding: '20px', color: '#999'}}>
                <p>No parent data found</p>
            </div>}
            {!isLoading && safeOrganisationCodes.length > 0 && <div className="table-design">
                {codeVal && <div style={{paddingLeft:"10px",color:"#45C096"}}>Parents link to {isNaN(codeVal)===true?'Contact Group':'code'} : {codeVal}<a className={style.backBtn}  href='#' onClick={()=>goBackParent(codeVal)}>Go Back</a></div>}
            <table className={"table table-hover " + style.categorytable}>
                <thead className={style.heading}>
                    <tr>
                        <th scope="col" onClick={() => handleSort('firstName')} style={{cursor: 'pointer', userSelect: 'none'}}>
                            First Name {getSortIcon('firstName')}
                        </th>
                        <th scope="col" onClick={() => handleSort('lastName')} style={{cursor: 'pointer', userSelect: 'none'}}>
                            Last Name {getSortIcon('lastName')}
                        </th>
                        <th scope="col" onClick={() => handleSort('email')} style={{cursor: 'pointer', userSelect: 'none'}}>
                            Email Address {getSortIcon('email')}
                        </th>
                        <th scope="col" onClick={() => handleSort('code')} style={{cursor: 'pointer', userSelect: 'none'}}>
                            Verification Code {getSortIcon('code')}
                        </th>
                        <th scope="col" onClick={() => handleSort('createDate')} style={{cursor: 'pointer', userSelect: 'none'}}>
                            Created Date {getSortIcon('createDate')}
                        </th>
                        <th scope="col" onClick={() => handleSort('codeUserStatus')} style={{cursor: 'pointer', userSelect: 'none'}}>
                            Status {getSortIcon('codeUserStatus')}
                        </th>
                        <th scope="col">Phone</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody className={style.tablebody}>

                    {parentData.map((user) => {

const dt = new Date(user.createDate);



const month = dt.toLocaleString('en-US', { month: 'short' });
const day = dt.toLocaleString('en-US', { day: '2-digit' });
const year = dt.getFullYear();
const createdDate = `${day + ' ' + month + ' ' + year}`;
                        return (
                            <tr key={user.id} className={user.codeUserStatus=='INACTIVE' ? 'deActiveRow' : ''}>


                                <td>{user.firstName}</td>
                                <td>{user.lastName}</td>
                                <td>{user.email}</td>
                                <td>{user.code}</td>
                                <td>{createdDate}</td>
                                <td>{user.codeUserStatus=='ACTIVE'?<p style={{margin:'0'}}><i className="fa fa-check" style={{ color: '#45c096' }}></i><span style={{color: '#45c096',marginLeft: '4px'}}>Active</span></p>:<p style={{margin:'0'}}><i className="fa fa-check" style={{ color: '#FF6D73' }}></i><span style={{color: '#FF6D73',marginLeft: '4px'}}>Inactive</span></p>}</td>
                                <td>0000000</td>
                                <td>
                                    {user.codeUserStatus==='ACTIVE' &&
                                        <div className={"form-check form-switch " + style.switchBtn}>
                                            <input 
                                                className={"form-check-input " + style.switchInput} 
                                                type="checkbox" 
                                                role="switch"
                                                id={`switch-parent-${user.uuid}`}
                                                title="Toggle user status"
                                                checked={true}
                                                onChange={() => deactiveNotificationHandler(user)}
                                            />
                                        </div>
                                    }
                                    {user.codeUserStatus==='INACTIVE' &&
                                        <div className={"form-check form-switch " + style.switchBtn}>
                                            <input 
                                                className={"form-check-input " + style.switchInput} 
                                                type="checkbox" 
                                                role="switch"
                                                id={`switch-parent-${user.uuid}`}
                                                title="Toggle user status"
                                                checked={false}
                                                onChange={() => deactiveNotificationHandler(user)}
                                            />
                                        </div>
                                    }
                                </td>
                            </tr>
                        )
                    })}

                </tbody>
            </table>
            <div className={"row justify-content-between " + tableStyle.listShow}>
                {totalCount > pageSize && <div className="col-4">
                    <label className={tableStyle.listLabel}>
                        Show
                        <select className={"form-select " + tableStyle.listSelect} value={PageSize} onChange={showHandler}>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </label>
                </div>}

                <div className="col-4">
                    <div style={{ float: 'right' }}>
                        <Pagination
                            currentPage={currentPage}
                            totalCount={searchParentData.length}
                            pageSize={PageSize}
                            onPageChange={page => setCurrentPage(page)}
                        />
                    </div>
                </div>

            </div>
            </div>
            }
            {modalIsOpen && <Modal status={status} isOpen={modalIsOpen} className="alertBgContainer" contentLabel="Example Modal" >
                <div className='alertBox'>
                    <h4 className={tableStyle.alertTitle}>Alert</h4>
                    <div>
                     <div>
                        <p className={fontSize.smSize + ' ' + font.fontRegular + ' ' + common.pTag}>Are you want to
                        {status.codeUserStatus==='ACTIVE'?(<b className={font.fontBold}> Deactivate </b>):(<b className={font.fontBold}> Activate </b>)}this user?</p>
                        <p className={fontSize.smSize + ' ' + font.fontRegular + ' ' + common.pTag}>This will cause user disappear from the SchoolLink app.</p>
                        <div className='bottomArea'>
                            <button onClick={modalClose} className={button.smBtn + ' ' + button.lightBrownButton}>Cancel</button>
                            {status.codeUserStatus==='ACTIVE'?(
                            <button onClick={i=>disableParent(status.uuid, status.code, status.codeUserStatus)} className={button.smBtn + ' ' + button.blueButton + ' ' + button.buttonSpaceLeft}>Yes</button>):(<button onClick={i=>enableParent(status.uuid,status.code)} className={button.smBtn + ' ' + button.blueButton + ' ' + button.buttonSpaceLeft}>Yes</button>)}
                        </div>
                    </div>
                    </div>
                </div>
            </Modal>
            }
        </>
    );
}

export default ParentsDetails;
